import { z } from 'zod';

import { normalizeName } from '@alamo/utils';

/** Validate the canonical name, including Unicode uppercase expansions. */
export function nameSchema(
  minLength = 0,
  maxLength = 255,
  requiredMessage = 'common:validation.required',
) {
  return z
    .string()
    .transform(normalizeName)
    .refine((value) => [...value].length >= minLength, requiredMessage)
    .refine((value) => [...value].length <= maxLength, 'common:validation.max_length');
}
